const BaseXform = require('../base-xform');

class CChartXform extends BaseXform {
  get tag() {
    return 'c:chart';
  }

  render(xmlStream, model) {
    // xmlStream.leafNode(this.tag, {
    //   'xmlns:r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
    //   'r:id': model.rId,
    //   'cstate': 'print',
    // });
    // TODO: handle children (e.g. a:extLst=>a:ext=>a14:useLocalDpi
  }

  parseOpen(node) {
    switch (node.name) {
      case this.tag:
        this.model = {
          rId: node.attributes['r:id'],
        };
        return true;
      default:
        return true;
    }
  }

  parseText() {}

  parseClose(name) {
    switch (name) {
      case this.tag:
        return false;
      default:
        // unprocessed internal nodes
        return true;
    }
  }
}

module.exports = CChartXform;
